export const SCHEMA_SCHOOLS = {
  source: 'landing',

  map: { contactName: 'contact_name', email: 'email', phone: 'phone', message: 'notes' },

  schoolName(a) {
    return a.school_name || a.district_name || '(not provided)';
  },

  confirmTail: 'team will review the details you shared and follow up by email with next steps.',

  sections: [
    {
      legend: 'Your details',
      help: 'So we know who to follow up with.',
      fields: [
        { id: 'contact_name', label: 'Full name', type: 'text', required: true, autocomplete: 'name',
          errorMessage: 'Please enter your name.' },
        { id: 'contact_role', label: 'Your role', type: 'select', required: true,
          placeholder: 'Select a role…',
          options: ['Superintendent or district administrator', 'Principal or school director',
                    'Curriculum or academic lead', 'CTE coordinator', 'Teacher',
                    'IT or operations', 'Other'] },
        { id: 'email', label: 'Work email', type: 'email', required: true,
          autocomplete: 'email', placeholder: 'you@yourschool.org' },
        { id: 'phone', label: 'Phone', type: 'tel', required: true, autocomplete: 'tel',
          errorMessage: 'Please enter a phone number.' }
      ]
    },
    {
      legend: 'Your organization',
      help: "Whether you're setting up a single school or a whole district changes how we get you started.",
      fields: [
        { id: 'org_type', label: 'Signing up as', type: 'radio', required: true, full: true,
          options: [{ value: 'school', label: 'A single school' },
                    { value: 'district', label: 'A district' }] },
        { id: 'district_name', label: 'District name', type: 'text', required: true,
          showIf: { field: 'org_type', equals: 'district' },
          errorMessage: 'Please enter the district name.' },
        { id: 'school_name', label: 'School name', type: 'text', required: true,
          errorMessage: 'Please enter the school name.' },
        { id: 'state', label: 'State', type: 'select', required: true,
          placeholder: 'Select a state…', options: 'US_STATES' },
        { id: 'website', label: 'Website', type: 'url', placeholder: 'https://' },
        { id: 'address', label: 'Mailing address', type: 'text', required: true, full: true,
          placeholder: 'Street, city, ZIP',
          errorMessage: "Please enter the school's mailing address." }
      ]
    },
    {
      legend: 'About your school',
      help: 'Rough numbers are fine — this helps us size your setup.',
      fields: [
        { id: 'grade_levels', label: 'Grade levels served', type: 'checkbox', full: true,
          options: [{ value: 'K-2', label: 'K–2' }, { value: '3-5', label: '3–5' },
                    { value: '6-8', label: '6–8' }, { value: '9-12', label: '9–12' }] },
        { id: 'student_count', label: 'Number of students', type: 'select', required: true,
          placeholder: 'Select a range…',
          options: ['Under 100', '100–500', '500–2,000', '2,000+'] },
        { id: 'teacher_count', label: 'Number of teachers', type: 'select', required: true,
          placeholder: 'Select a range…',
          options: ['Under 10', '10–50', '50–200', '200+'] },
        { id: 'admin_count', label: 'Administrative staff', type: 'select', required: true,
          placeholder: 'Select a range…', options: ['Under 5', '5–20', '20+'] },
        { id: 'program_focus', label: 'Program focus', type: 'select', required: true,
          options: ['Core academic', 'CTE', 'Both'] }
      ]
    },
    {
      legend: "What you're looking for",
      help: 'Tick anything that applies — it helps us prepare the right walkthrough.',
      fields: [
        { id: 'interests', label: 'Interested in', type: 'checkbox', full: true,
          options: [{ value: 'sis', label: 'Student information system' },
                    { value: 'lms', label: 'Curriculum and lessons' },
                    { value: 'cte', label: 'CTE pathways' },
                    { value: 'parent', label: 'Parent portal' },
                    { value: 'reporting', label: 'State reporting and compliance' },
                    { value: 'ai', label: 'AI-assisted course building' }] },
        { id: 'target_start', label: 'When would you like to start?', type: 'select',
          options: ['As soon as possible', 'This semester', 'Next semester',
                    'Next school year', 'Just exploring'] },
        { id: 'notes', label: 'Anything else we should know?', type: 'textarea', full: true,
          placeholder: 'Goals, timelines, questions, anything that would help us prepare.' }
      ]
    }
  ]
};
